<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button type="button" class="btn-close" data-bs-theme="dark" aria-label="Luk" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <p>{{ description }}</p>
    <div class="bg-body-tertiary border-start border-danger border-3 p-3 mb-3 text-break" role="alert">
        @if (errorCodes.length) {
            <div class="small text-body-secondary mb-1">Fejlkode fra e-conomic</div>
            @for (code of errorCodes; track code) {
                <div class="fs-5 mb-2">{{ code }}</div>
            }
        } @else {
            <div class="small text-body-secondary mb-1">{{ responseStatus ? 'Fejlbesked fra e-conomic' : 'Fejlbesked' }}</div>
        }
        <div class="error-message">{{ readableMessage }}</div>
    </div>
    <details class="mb-4">
        <summary class="text-body-secondary">Tekniske detaljer</summary>
        <dl class="row mt-3 mb-0 small">
            <dt class="col-sm-4">Trin</dt><dd class="col-sm-8">{{ stageLabel }}</dd>
            @if (responseStatus) {
                <dt class="col-sm-4">HTTP-status fra e-conomic</dt><dd class="col-sm-8">{{ responseStatus }}</dd>
            }
            @if (failure.stage === 'documents') {
                @if (failure.attachmentInvoiceNumber != null) {
                    <dt class="col-sm-4">Faktura / PDF</dt><dd class="col-sm-8">Faktura-{{ failure.attachmentInvoiceNumber }}.pdf</dd>
                }
                @if (failure.attachmentVoucherNumber != null) {
                    <dt class="col-sm-4">Bilagsnummer</dt><dd class="col-sm-8">{{ failure.attachmentVoucherNumber }}</dd>
                }
                @if (failure.attachmentAccountingYear) {
                    <dt class="col-sm-4">Regnskabsår</dt><dd class="col-sm-8">{{ failure.attachmentAccountingYear }}</dd>
                }
                @if (failure.attachmentFileSize != null) {
                    <dt class="col-sm-4">PDF-størrelse</dt><dd class="col-sm-8">{{ failure.attachmentFileSize }} bytes (maks. 9437184)</dd>
                }
            }
            @if (endpoint) {
                <dt class="col-sm-4">API-endpoint</dt><dd class="col-sm-8 text-break">{{ endpoint }}</dd>
            }
            @if (failure.category === 'partial') {
                <dt class="col-sm-4">Kladdeposter</dt><dd class="col-sm-8">Oprettet</dd>
                <dt class="col-sm-4">PDF-filer vedhæftet</dt><dd class="col-sm-8">{{ failure.attachmentsCompleted }}</dd>
            }
        </dl>
        @if (formattedResponse) {
            <div class="small text-body-secondary mt-2 mb-1">Svar fra e-conomic</div>
            <pre class="response-json bg-body-tertiary rounded p-3 mb-0 small">{{ formattedResponse }}</pre>
        }
    </details>
    <div class="d-flex flex-wrap justify-content-between gap-2">
        <a class="btn btn-outline-primary" href="https://secure.e-conomic.com/" target="_blank" rel="noopener noreferrer">Åbn e-conomic <span aria-hidden="true">↗</span></a>
        <button type="button" class="btn btn-primary ms-auto" (click)="activeModal.close()">Luk</button>
    </div>
</div>
